import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import React, { useState, useEffect } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tabs/style/react-tabs.css';

import { Alert, ConfigService, TransactionService } from '../../services';
import Pagination from '../../components/Pagination';
//service
import 'react-tooltip/dist/react-tooltip.css';
import 'react-loading-skeleton/dist/skeleton.css';
import TableComponent from '../../components/TableComponent';
import SortByFilter from '../../components/listing/SortByFilter';
import { formatValue } from '../../utils/Helper';
import CopyToClipboardText from '../../components/CopyToClipboardText';
import StatusBadge from '../../components/StatusBadge';
import SearchInput from '../../components/SearchInput';
import { DownloadIcon } from '../../components/icons/IconProvider';

const ManageFiatTransaction = () => {
  const [fiatTransactionList, setFiatTransactionList] = useState([]);
  const [onChainTransaction, setOnChainTransactionList] = useState([]);
  const [isTabStatus, setTabStatus] = useState(1);
  const [isFiatLoader, setFiatLoader] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });

  const tableConfigFiat = {
    columns: {
      user_name: {
        title: 'User Name',
        render: (data) => {
          return (
            <>
              <span className="font-medium">
                {data?.userDetail?.full_name ? data.userDetail.full_name : 'NA'}
              </span>
              <span className="block text-gray-600 max-w-[150px] truncate">
                {data?.userDetail?.email ? data.userDetail.email : 'NA'}
              </span>
            </>
          );
        },
      },
      type: {
        title: 'Type',
        render: (data) => {
          return data?.type ? data.type : '--';
        },
      },
      project: {
        title: 'Project',
        render: (data) => {
          return (
            <div className="flex items-center font-semibold text-md">
              <img
                src={data?.projectDetail?.projectsType?.icon_url}
                className="mr-2"
                alt=""
              />
              {data?.projectDetail?.name || '--'}
            </div>
          );
        },
      },
      transaction_id: {
        title: 'Transaction Id',
        render: (data) => {
          return (
            <span className="text-brandBlue font-semibold inline-block">
              {data?.transactions_id || 'NA'}
            </span>
          );
        },
      },
      payment_method: {
        title: 'Payment Method',
        render: (data) => {
          const paymentAmt = Number(data?.amount);
          const voucherAmt = Number(data?.voucherUtilize?.discount_amount);
          return paymentAmt > 0 && voucherAmt > 0 ? (
            <>
              <span className="font-medium">
                {data?.payment_method +
                  ': ' +
                  formatValue(paymentAmt, {
                    decimalPlaces: 2,
                  })}
              </span>
              <span className="block font-medium">
                {'voucher: ' +
                  formatValue(voucherAmt, {
                    decimalPlaces: 2,
                  })}
              </span>
            </>
          ) : (
            <span className="font-medium">{data?.payment_method ?? 'N/A'}</span>
          );
        },
      },
      quantity: {
        title: 'QTY',
        render: (data) => {
          return data?.quantity ? data.quantity : 'NA';
        },
      },
      amount: {
        title: 'Amount',
        render: (data) => {
          return (
            <span className="text-brandBlue font-semibold inline-block">
              {data?.total_amount
                ? formatValue(data?.total_amount, {
                    decimalPlaces: 2,
                  })
                : '0'}
            </span>
          );
        },
      },
      created_at: {
        title: 'Created',
        render: (data) => {
          return ConfigService.dateFormat(data?.created_at, true);
        },
      },
      completed_at: {
        title: 'Completed',
        render: (data) => {
          return ConfigService.dateFormat(data?.updated_at, true);
        },
      },
      status: {
        title: 'Status',
        render: (data) => {
          return <StatusBadge status={data?.status} />;
        },
      },
      action: {
        title: 'Action',
        render: (data) => {
          const pdfUrl = data?.pdf_url;
          const tooltipId = `action_download_tooltip_${data?.id}`;

          return (
            <div className="relative inline-block">
              {pdfUrl && (
                <>
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-tooltip-id={tooltipId}
                  >
                    <DownloadIcon />
                  </a>
                  <ReactTooltip
                    id={tooltipId}
                    place="top"
                    content="Purchase Order"
                  />
                </>
              )}
            </div>
          );
        },
      },
    },
    data: fiatTransactionList,
  };

  const tableConfigOnchain = {
    columns: {
      transaction_type: {
        title: 'Transaction Type',
        render: (data) => {
          return (
            <span className="bg-[#85919F] py-[2px] px-3 rounded-md text-white font-semibold inline-block uppercase text-xs ">
              {data?.type ? data.type : '--'}
            </span>
          );
        },
      },
      project: {
        title: 'Project',
        render: (data) => {
          return (
            <>
              <div className="flex items-center font-semibold text-md">
                <img
                  src={data?.projectDetail?.projectsType?.icon_url}
                  className="mr-2"
                  alt=""
                />
                <p className="font-medium truncate">
                  {data?.projectDetail?.name || '--'}
                </p>
              </div>
              <div className="break-all w-28 text-BlueText pr-5 flex items-center">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={data?.txnHashURL || '#'}
                  className="flex items-center"
                >
                  <img
                    src="/img/linkdirection-icon.svg"
                    className="mr-2"
                    alt=""
                  />
                  <div className="w-24 overflow-ellipsis whitespace-nowrap overflow-hidden">
                    {data?.hash || '--'}
                  </div>
                </a>
              </div>
            </>
          );
        },
      },
      from: {
        title: 'From',
        render: (data) => {
          return (
            <>
              <p
                data-tooltip-id={`from_wallet_address${data?.id}`}
                className="break-all w-24 truncate text-BlueText"
              >
                {data?.fromUser?.id === 1
                  ? 'Issuer'
                  : data?.fromUser?.full_name || 'NA'}
              </p>
              <ReactTooltip
                id={`from_wallet_address${data?.id}`}
                place="bottom"
                content={data?.from_wallet_address}
              />
            </>
          );
        },
      },
      to: {
        title: 'To',
        render: (data) => {
          return (
            <>
              <div className="flex items-center font-semibold text-md">
                <p className="font-medium truncate">
                  {data?.toUser?.full_name || '--'}
                </p>
              </div>

              <div className=" flex justify-center">
                <p
                  data-tooltip-id={`to_wallet_address${data?.id}`}
                  className="break-all w-24 truncate text-BlueText"
                >
                  {data?.to_wallet_address
                    ? ConfigService.shortenAddress(data.to_wallet_address)
                    : '--'}
                </p>

                <ReactTooltip
                  id={`to_wallet_address${data?.id}`}
                  place="bottom"
                  content={data?.to_wallet_address}
                />

                {data?.to_wallet_address && (
                  <CopyToClipboardText
                    text={data.to_wallet_address}
                    copyMessage={'Wallet Address Copied!'}
                  />
                )}
              </div>
            </>
          );
        },
      },
      tokens: {
        title: 'Tokens',
        render: (data) => {
          return data?.quantity ? data.quantity : '--';
        },
      },
      created_at: {
        title: 'Date',
        render: (data) => {
          return ConfigService.dateFormat(data?.created_at, true);
        },
      },
      status: {
        title: 'Status',
        render: (data) => {
          return (
            <StatusBadge
              status={data?.status === 1 ? 'transferred' : 'transfer_pending'}
            />
          );
        },
      },
    },
    data: onChainTransaction,
  };

  /* filter data */
  const [commonSearch, setCommonSearch] = useState('');
  const [sortBy, setSortBy] = useState('');

  const [filterFiatData, setFilterFiatData] = useState({
    perPage: 8,
    page: 1,
    commonSearch: '',
    date: '',
    type: '',
    status: '',
  });
  const [filterOnChainData, setFilterOnChainData] = useState({
    perPage: 8,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: '',
    type: '',
  });

  useEffect(() => {
    (async () => {
      await getTransactionList();
    })();
  }, [filterOnChainData, filterFiatData]);

  const getTransactionList = async () => {
    try {
      //call fiat transaction api
      setFiatLoader(true);
      let fiatResponse = await TransactionService.getFiatTransactionList(
        filterFiatData.perPage,
        filterFiatData.page,
        filterFiatData.commonSearch,
        filterFiatData.date,
        filterFiatData.type,
        filterFiatData.status,
      );
      if (fiatResponse.status === 'failure') {
        setFiatLoader(false);
        Alert.error(fiatResponse.message);
        return false;
      }

      setFiatTransactionList([...fiatResponse.data.records]);
      if (isTabStatus === 1) {
        setPagination({
          totalPages: fiatResponse.data.pagination.totalPages,
          currentPage: fiatResponse.data.pagination.page,
        });
      }
      // call on chain  transaction api

      let onchainResponse = await TransactionService.getOnchainTransactionList(
        filterOnChainData.perPage,
        filterOnChainData.page,
        filterOnChainData.commonSearch,
        filterOnChainData.sortBy,
        filterOnChainData.project_id,
        filterOnChainData.type,
      );

      if (onchainResponse.status === 'failure') {
        setFiatLoader(false);
        Alert.error(onchainResponse.message);
        return false;
      }
      if (isTabStatus === 2) {
        setPagination({
          totalPages: onchainResponse.data.pagination.totalPages,
          currentPage: onchainResponse.data.pagination.page,
        });
      }
      setOnChainTransactionList([...onchainResponse.data.records]);
      setFiatLoader(false);
    } catch (error) {
      setFiatLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = () => {
    if (isTabStatus === 1) {
      setTabStatus(1);
      setFilterFiatData({
        ...filterFiatData,
        page: 1,
        commonSearch: commonSearch,
        status: filterFiatData.status,
      });
    } else {
      setTabStatus(2);
      setFilterOnChainData({
        ...filterOnChainData,
        page: 1,
        commonSearch: commonSearch,
        type: filterOnChainData.type,
      });
    }
  };

  const tabSwitch = async (_type) => {
    if (_type === 1) {
      setTabStatus(1);
      setFilterFiatData({
        ...filterFiatData,
        page: 1,
      });
      await getTransactionList();
    } else {
      setTabStatus(2);
      setFilterOnChainData({
        ...filterOnChainData,
        page: 1,
      });
      await getTransactionList();
    }
  };
  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    if (isTabStatus === 1) {
      setFilterFiatData({
        ...filterFiatData,
        page: current,
      });
    } else {
      setFilterOnChainData({
        ...filterOnChainData,
        page: current,
      });
    }
  };
  const resetFilter = () => {
    setSortBy('');
    setCommonSearch('');
    setFilterFiatData({
      ...filterFiatData,
      page: 1,
      commonSearch: '',
      sortBy: '',
      status: '',
    });
    setFilterOnChainData({
      ...filterOnChainData,
      page: 1,
      commonSearch: '',
      sortBy: '',
      type: '',
    });
  };

  const fiatStatusOptions = [
    { value: '', label: 'Filter by' },
    { value: 'created', label: 'Created' },
    { value: 'pending', label: 'Pending' },
    { value: 'completed', label: 'Completed' },
    { value: 'failed', label: 'Failed' },
  ];

  const onChainTypeOptions = [
    { value: '', label: 'Filter by' },
    { value: 'purchase', label: 'Purchase' },
    { value: 'transfer', label: 'Transfer' },
  ];

  return (
    <div>
      <div className="grid mb-4">
        <h4 className="">Transactions</h4>
      </div>

      <div className="w-full bg-brandGray md:px-5 px-4 py-4 rounded-xl">
        <div className="relative overflow-x-auto ">
          <Tabs>
            <div className="lg:grid lg:grid-cols-2 gap-4">
              <TabList className="flex">
                <Tab
                  className="rounded-responsive-text"
                  onClick={() => tabSwitch(1)}
                >
                  Fiat Transactions{' '}
                </Tab>
                <Tab
                  className="rounded-responsive-text"
                  onClick={() => tabSwitch(2)}
                >
                  On Chain Transactions
                </Tab>
              </TabList>
              <div className="lg:text-right md:flex items-center gap-3 lg:justify-end lg:mt-0 mt-3">
                <div className="inline-flex  relative md:w-auto w-full md:mb-0 mb-2">
                  <SortByFilter
                    value={
                      isTabStatus === 1
                        ? filterFiatData.status
                        : filterOnChainData.type
                    }
                    dropdownList={
                      isTabStatus === 1 ? fiatStatusOptions : onChainTypeOptions
                    }
                    filterData={
                      isTabStatus === 1 ? filterFiatData : filterOnChainData
                    }
                    setFilterData={
                      isTabStatus === 1
                        ? setFilterFiatData
                        : setFilterOnChainData
                    }
                    fieldName={isTabStatus === 1 ? 'status' : 'type'}
                  />
                </div>
                <div className="lg:mx-2 inline-flex relative min-w-full md:min-w-[200px] mb-2 md:mb-0">
                  <SearchInput
                    name="commonSearch"
                    id="commonSearch"
                    onChange={(e) => {
                      searchData();
                      setCommonSearch(e.target.value);
                    }}
                    value={commonSearch}
                  />
                </div>
                <p
                  className="text-blue-700 rounded bg-blue-500 bg-opacity-5 text-center font-medium text-sm inline-block cursor-pointer h-[42px] py-3 px-2 min-w-[100px]"
                  onClick={() => resetFilter()}
                >
                  Clear filters
                </p>
              </div>
            </div>

            <TabPanel>
              <div className="flex flex-col relative overflow-x-auto w-full  sm:rounded-lg mt-4">
                <TableComponent
                  tableConfig={tableConfigFiat}
                  isListLoader={isFiatLoader}
                  isList={fiatTransactionList}
                />
              </div>
              {fiatTransactionList &&
                fiatTransactionList.length > 0 &&
                isFiatLoader === false && (
                  <Pagination
                    total={isPagination.totalPages}
                    current={isPagination.currentPage}
                    pagination={(crPage) => handlePagination(crPage)}
                  />
                )}
            </TabPanel>
            <TabPanel>
              <div className="flex flex-col relative overflow-x-auto w-full sm:rounded-lg mt-4">
                <TableComponent
                  tableConfig={tableConfigOnchain}
                  isListLoader={isFiatLoader}
                  isList={onChainTransaction}
                />
              </div>
              {onChainTransaction &&
                onChainTransaction.length > 0 &&
                isFiatLoader === false && (
                  <Pagination
                    total={isPagination.totalPages}
                    current={isPagination.currentPage}
                    pagination={(crPage) => handlePagination(crPage)}
                  />
                )}
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
};
export default ManageFiatTransaction;
